'use strict'

import * as types from './types';

export const getWeekNav = (username, date) => ({
	type: types.GET_WEEK_NAV,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/weekNav`,
		method: 'GET',
		params: {
			username,
			date,
		},
	},
});

export const getDayNav = (username, date) => ({
	type: types.GET_DAY_NAV,
	meta: {
		async: true,
		endPoint: `/user/${ username }/${ date }/dayNav`,
		method: 'GET',
		params: {
			username,
			date,
		},
	},
});

export const updateLocation = location => ({
	type: types.UPDATE_LOCATION,
	data: location,
});

export const updateClientWidth = width => ({
	type: types.UPDATE_CLIENT_WIDTH,
	data: width,
});

export const updateUrlParams = params => ({
	type: types.UPDATE_URL_PARAMS,
	data: params,
});

export const setActionMode = actionType => ({
	type: types.SET_ACTION_MODE,
	data: actionType,
});

export const setPage = page => ({
	type: types.SET_PAGE,
	data: page,
});

export const setResponsive = responsive => ({
	type: types.SET_RESPONSIVE,
	data: responsive,
});

export const setPageContext = ctx => ({
	type: types.SET_PAGE_CONTEXT,
	data: ctx,
});

export const setPageLoaded = url => ({
	type: types.SET_PAGE_LOADED,
	data: url,
});

export const setPageId = pageId => ({
	type: types.SET_PAGE_ID,
	data: pageId,
});

export const setModalOpen = (id, props) => ({
	type: types.SET_MODAL_OPEN,
	data: {
		id,
		props,
	},
});

export const setModalClose = modalId => ({
	type: types.SET_MODAL_CLOSE,
	data: modalId,
});

export const setJob = (jobId, companyId) => ({
	type: types.SET_JOB,
	data: {
		jobId,
		companyId,
	},
});

export const setMenuOpen = () => ({
	type: types.SET_MENU_OPEN,
	data: {},
});

export const setMenuClose = () => ({
	type: types.SET_MENU_CLOSE,
	data: {},
});

export const setUsersLoaded = () => ({
	type: types.SET_USERS_LOADED,
	data: {},
});
